import React from "react";
import toast from "react-hot-toast";
import { Button, Checkbox } from "../Components";

import './../Components/Modal/modal.css'
/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ConfirmationModal = ({ type = 'info',
        size ='medium',
        open,
        title,
        labels = {confirm : 'Confirm' ,
        cancel : 'Cancel'} ,
        message,
        options = false ,
        onConfirm,
        onCancel 
    }) => {

    const [fields, setFields] = React.useState([])

    const onChange = (params) => {
        //console.log(params );
        
        if(params.target.type === 'checkbox'){
            
            if(params.target.checked) setFields([...fields , params?.target?.value])
            else {
                let fields_tmp = [...fields]
                const index = fields_tmp.indexOf(params.target.value)
                fields_tmp.splice(index , 1)
                setFields(fields_tmp)
                
            }
        }else if(params.target.type === 'radio'){
            setFields([params.target.value])
        }
    }

	return (
		<div className={`modal ${open ? 'show' : ''} ${type} ${size}`}   onClose={onCancel}>
			<div className="modal-dialog">
				<div className="modal-title">{title}</div>
				<div className="modal-content">
					<div>{message}</div>
				</div>
                {
                    options && options?.data?.length > 0 && 
                    <div className="modal-options">
                        {
                            options?.parameters?.multichoise === true 
                            ? <>
                            {
                                options?.data?.map( (option , index) => {
                                    return (
                                        <div key={index} className="fields ">
                                            {/* <label><input type={`checkbox`} name={``} id={``} /> {option?.name}</label>  */}
                                            <Checkbox 
                                                label={option?.name}
                                                value={option?.id}
                                                onChange={onChange} 
                                            />
                                        </div>

                                    )
                                })
                            }
                            </>
                            :<>
                            {
                                options?.data?.map( (option , index) => {
                                    return (
                                        <div key={index} className="fields ">
                                            <label>
                                                <input 
                                                    type={`radio`} 
                                                    name={`option--${options?.data[0]?.id}`} 
                                                    id={``} 
                                                    value={option?.id} 
                                                    onChange={onChange} 
                                                    /> {option?.name}</label> 
                                        </div>

                                    )
                                })
                            }
                            </>
                        }
                    </div>
                }
				<div className="modal-actions">
					<Button color="info" onClick={onCancel}>{labels?.cancel ?? 'Cancel'}</Button>
					<Button color={type =='danger' ? 'red' : 'purple'} variant="contained" onClick={(e) => onConfirm(fields)}>{labels?.confirm ?? 'Confirm'}</Button>
				</div>

			</div>
		</div>
	);
};

const ConfirmationModalContext = React.createContext({});

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const NotificationsProvider = ({ children }) => {

	const [modalOpen, setModalOpen] = React.useState(false);
	const [modalConfig, setModalConfig] = React.useState({});
    const [options, setOptions] = React.useState([])
    const [option, setOption] = React.useState(null)

	const openModal = ({ type , size , title, message, labels , options , actionCallback , onConfirm , onCancel }) => {
		setModalOpen(true);
		setModalConfig({ type , size , title, message, labels , options , actionCallback,  onConfirm , onCancel});
	};

	const resetModal = () => {
		setModalOpen(false);
		setModalConfig({});
	};

	const onConfirm = (response) => {
        if(modalConfig.options?.data && modalConfig?.options?.data?.length > 0  ){
            
            if(response && response?.length > 0 ){
                
                resetModal();
                modalConfig.actionCallback(true);
                modalConfig.onConfirm(response);
            }else{
                toast.error('Please complete all required fields')
            }

        }else {
            resetModal();
            modalConfig.actionCallback(true);
            modalConfig.onConfirm(response);
        }
		
	};
	
	const onCancel = () => {
		resetModal();
		modalConfig.actionCallback(false);
		modalConfig.onCancel();
	};

	return (
		<ConfirmationModalContext.Provider value={{ openModal }}>
			{children}
			{
				modalOpen && 
				<ConfirmationModal
					open={modalOpen}
					size={modalConfig?.size}
					type={modalConfig?.type}
					title={modalConfig?.title}
					labels={modalConfig?.labels}
					message={modalConfig?.message}
                    options={modalConfig?.options}
					onConfirm={onConfirm}
					onCancel={onCancel}
				/>
			}
		</ConfirmationModalContext.Provider>
	);
};

/**
 * 
 * @returns 
 */
const useConfirmationModal = () => {
  const { openModal } = React.useContext(ConfirmationModalContext);

  const getConfirmation = ({ ...options }) =>
	new Promise((res) => {
	  openModal({ actionCallback: res, ...options });
	});

  return { getConfirmation };
};

export default ConfirmationModal;
export { NotificationsProvider, useConfirmationModal };
